module.exports = {
	"id": "ER",
	"name": "Eritrea",
	"month": "2016-10",
	"access_date": "2016-11-03",
	"data": {
		"chrome": {
			"4": null,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"11": null,
			"12": null,
			"13": null,
			"14": null,
			"15": null,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": null,
			"30": 0.462144,
			"31": 0.016704,
			"32": 0.016704,
			"33": null,
			"34": null,
			"35": null,
			"36": null,
			"37": null,
			"38": null,
			"39": null,
			"40": null,
			"41": null,
			"42": 0.011136,
			"43": 0.211584,
			"44": 0.016704,
			"45": 0.545664,
			"46": 0.02784,
			"47": null,
			"48": null,
			"49": 0.239424,
			"50": 0.02784,
			"51": 0.066816,
			"52": 0.133632,
			"53": 3.485568,
			"54": 0.373056,
			"55": null,
			"56": null,
			"57": null
		},
		"firefox": {
			"2": null,
			"3": 0.061248,
			"4": 0.684864,
			"5": 0.512256,
			"6": 0.016704,
			"7": 0.066816,
			"8": 0.150336,
			"9": 0.066816,
			"10": 0.08352,
			"11": 0.155904,
			"12": 0.645888,
			"13": 0.105792,
			"14": 0.183744,
			"15": 0.434304,
			"16": 0.094656,
			"17": 0.512256,
			"18": 0.902016,
			"19": 0.423168,
			"20": 0.022272,
			"21": 0.272832,
			"22": 0.384192,
			"23": 0.272832,
			"24": 0.016704,
			"25": 0.05568,
			"26": 0.36192,
			"27": 0.044544,
			"28": 0.707136,
			"29": 0.11136,
			"30": 1.83744,
			"31": 0.61248,
			"32": 0.105792,
			"33": 3.496704,
			"34": 0.462144,
			"35": 0.295104,
			"36": 11.592576,
			"37": 0.206016,
			"38": 0.696,
			"39": 0.373056,
			"40": 1.230528,
			"41": 0.478848,
			"42": 2.427648,
			"43": 3.98112,
			"44": 1.1136,
			"45": 0.50112,
			"46": 0.228288,
			"47": 3.101376,
			"48": 2.266176,
			"49": 4.532352,
			"50": 0.506688,
			"51": null,
			"52": null,
			"3.5": 0.105792,
			"3.6": 0.311808
		},
		"opera": {
			"9": null,
			"11": 0.011136,
			"12": null,
			"15": 0.133632,
			"16": null,
			"17": null,
			"18": null,
			"19": null,
			"20": null,
			"21": null,
			"22": null,
			"23": null,
			"24": null,
			"25": null,
			"26": null,
			"27": null,
			"28": null,
			"29": 0.011136,
			"30": 0.050112,
			"31": null,
			"32": null,
			"33": null,
			"34": null,
			"35": null,
			"36": 0.011136,
			"37": null,
			"38": null,
			"39": 0.05568,
			"40": 0.311808,
			"41": null,
			"42": null,
			"43": null,
			"9.5-9.6": null,
			"10.0-10.1": 0,
			"10.5": null,
			"10.6": null,
			"11.1": null,
			"11.5": null,
			"11.6": 0.02784,
			"12.1": null
		},
		"safari": {
			"0": null,
			"4": 0.016704,
			"5": null,
			"6": null,
			"7": null,
			"8": null,
			"9": null,
			"10": null,
			"3.1": null,
			"3.2": null,
			"5.1": null,
			"6.1": null,
			"7.1": null,
			"9.1": 0.02784
		},
		"ios_saf": {
			"8": 0,
			"10": 0.563524556203,
			"3.2": 0,
			"4.0-4.1": 0,
			"4.2-4.3": 0,
			"5.0-5.1": 0,
			"6.0-6.1": 0,
			"7.0-7.1": 0.0151863347211,
			"8.1-8.4": 0.0280561099084,
			"9.0-9.2": 0.0133845661948,
			"9.3": 0.204200432973
		},
		"android": {
			"3": 0,
			"4": 0.0941141498708,
			"53": null,
			"2.1": 0,
			"2.2": 0,
			"2.3": 0.0117642687339,
			"4.1": 0.339483183463,
			"4.2-4.3": 0.848707958656,
			"4.4": 1.94614617054,
			"4.4.3-4.4.4": 1.96295226873
		},
		"ie": {
			"6": 0.155904,
			"7": null,
			"8": 0.30624,
			"9": 0.022272,
			"10": 0.217152,
			"11": 0.534528,
			"5.5": null
		},
		"op_mob": {
			"0": 0.123785189689,
			"10": 0,
			"11": 0,
			"12": 0,
			"11.1": 0,
			"11.5": 0,
			"12.1": 0.00343847749136
		},
		"edge": {
			"12": 0.072384,
			"13": 0.022272,
			"14": 0.016704
		},
		"ie_mob": {
			"10": 0.00961307042254,
			"11": 0.0391389295775
		},
		"bb": {
			"7": 0.001108,
			"10": null
		},
		"samsung": {
			"0": 0.802192
		},
		"and_uc": {
			"0": 15.250512
		},
		"op_mini": {
			"0": 1.66773633282
		},
		"and_chr": {
			"0": 20.244688
		},
		"and_ff": {
			"0": 0.226032
		}
	},
	"total": 99.847476
};


/*****************
 ** WEBPACK FOOTER
 ** ./~/caniuse-db/region-usage-json/ER.json
 ** module id = 515
 ** module chunks = 0
 **/